import { defineDisableEnableFieldsDialog } from "./disableFields/DisableEnableFieldsDialog"
import { EditBoundaryCtrl } from "./edit/boundary/boundary"
import { EditCroppingCtrl } from "./edit/cropping"
import { CroppingAttrsEditorCtrl } from "./edit/cropping/attributes"
import { EditCompositionCtrl } from "./edit/cropping/composition/composition"
import { FieldsEditService } from "./edit/editService"
import { createFieldEditor } from "./edit/field"
import { FieldsModule } from "./fields"
import { FieldFilterCtrl } from "./filter/filter"
import { GrassMarginEditorCtrl } from "./grassMargin/grassMargin"
import { IffEditorCtrl } from "./infieldFeatures/infieldFeatures"
import { MapContextMenuCtrl } from "./map/contextMenu"
import { CroppingDetailsCtrl } from "./map/croppingDetails/croppingDetails"
import { createMapView } from "./map/view"
import { createMenu } from "./menu/menu"
import { createMergeComponent } from "./merge/merge"
import { FieldsService } from "./services/service"
import { SplitCtrl } from "./split/split"
import { defineEditCropColoursReact } from "./styles/ui/EditCropColours"
import { ReactCtrl } from "./timeline/react/view"

export function setup(module: ng.IModule) {

    module

        .service("OmniaFieldsService", FieldsService)

        .service("OmniaFieldsEditService", FieldsEditService)

        .directive("omniaFields", FieldsModule.create)

        .directive("omniaFieldsMenu", createMenu)

        .directive("omniaFieldsEditCroppings", EditCroppingCtrl.create)
        .directive("omniaFieldsEditFields", createFieldEditor)
        .directive("omniaFieldsEditBoundary", EditBoundaryCtrl.create)
        .directive("omniaFieldsEditComposition", EditCompositionCtrl.create)
        .directive("omniaFieldsEditCroppingAttrs", CroppingAttrsEditorCtrl.create)

        .directive("omniaFieldsFilterPopup", FieldFilterCtrl.create)

        .service("OmniaFieldsMapContext", omnia.fields.map.FieldsMapContainerContext)
        .service("OmniaFieldsMapFactory", omnia.fields.map.FieldsMapFactory)
        .directive("omniaFieldsMap", createMapView)
        .directive("omniaFieldsMapContextMenu", MapContextMenuCtrl.create)

        .directive("omniaFieldsMapCroppingDetails", CroppingDetailsCtrl.create)

        .directive("omniaFieldsTimeline", ReactCtrl.create)

        .directive("omniaFieldsSplitCropping", SplitCtrl.create)
        .directive("omniaFieldsMergeCropping", createMergeComponent)
        .directive("omniaFieldsEditInfieldFeatures", IffEditorCtrl.create)
        .directive("omniaFieldsEditGrassMargin", GrassMarginEditorCtrl.create)

        .directive("omniaFieldsDisableDialog", defineDisableEnableFieldsDialog)

        .directive("omniaFieldsStylesDialog", defineEditCropColoursReact)


}
